import { quantityLabel } from '../../data/lists';
import type { ListItemRow } from '../../db/types';

interface Props {
  item: ListItemRow;
  /** Wyciszony wygląd (pozycja odhaczona). */
  muted?: boolean;
  /** Dopisana przez domownika w trakcie moich zakupów. */
  fresh?: boolean;
  /** Miejsce na trasie zgadnięte przez AI (jeszcze niepotwierdzone odhaczeniem). */
  guessed?: boolean;
  /** Cena przy pozycji (ostatnia z paragonów albo zapłacona). */
  price?: string | null;
  /** Promocja na tę pozycję w Lidlu, np. „−30% · do pt. 16.10”. */
  promo?: string | null;
  /** Dodatkowa treść pod nazwą i notatką (np. propozycja zamiennika). */
  children?: React.ReactNode;
}

/** Nazwa pozycji (duża), ilość obok, notatka pod spodem. */
export function ItemText({ item, muted = false, fresh = false, guessed = false, price = null, promo = null, children }: Props) {
  const qty = quantityLabel(item);
  return (
    <div className="min-w-0 flex-1 py-2.5">
      <div className={`text-lg leading-snug break-words ${muted ? 'text-stone-500 dark:text-stone-400' : ''}`}>
        {item.name}
        {guessed && (
          <span role="img" aria-label="miejsce zgadnięte" title="Miejsce zgadnięte" className="ml-1.5 align-middle text-sm text-violet-500 dark:text-violet-300">
            ✦
          </span>
        )}
        {qty && <span className="ml-2 text-sm font-medium whitespace-nowrap text-stone-500 dark:text-stone-400">{qty}</span>}
        {price && <span className="ml-2 text-sm whitespace-nowrap text-stone-400 tabular-nums dark:text-stone-500">{price}</span>}
        {fresh && (
          <span className="ml-2 inline-block rounded-full bg-sky-100 px-2 py-0.5 align-middle text-xs font-semibold text-sky-800 dark:bg-sky-900/50 dark:text-sky-200">
            nowa
          </span>
        )}
      </div>
      {item.note && <div className="text-sm text-amber-700 dark:text-amber-300">{item.note}</div>}
      {promo && (
        <div className="mt-0.5">
          <span className="inline-block max-w-full truncate rounded-full bg-amber-100 px-2 py-0.5 align-middle text-xs font-semibold text-amber-800 dark:bg-amber-900/40 dark:text-amber-200">
            % {promo}
          </span>
        </div>
      )}
      {children}
    </div>
  );
}
